import type { FC } from 'react';

import { Box, Link, Paragraph, useColorModeValue } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import type { SourceFileBannerState } from '../hooks/useSourceFileBanner';

const SETTINGS_URL = '/settings/videos/upload_defaults';

type Props = Extract<SourceFileBannerState, { show: true }>;

const replacements = {
  LINK: (text: string) => (
    <Link
      href={SETTINGS_URL}
      target="_blank"
      key="source-file-settings-link"
      style={{ textDecoration: 'underline' }}
    >
      {text}
    </Link>
  ),
};

export const SourceFileBanner: FC<Props> = (props) => {
  const bg = useColorModeValue('blue.100', 'rgba(26, 54, 93, 0.48)');

  return (
    <Box backgroundColor={bg} borderRadius="md" px="md" py={3}>
      <Paragraph size="md" color="text-primary">
        <strong>{translate('Original quality')}</strong>
        {' · '}
        {props.variant === 'countdown'
          ? translate({
              singular:
                'The original file you uploaded will be deleted in {DAYS} day. {LINK}Keep source files available{/LINK}',
              plural:
                'The original file you uploaded will be deleted in {DAYS} days. {LINK}Keep source files available{/LINK}',
              count: props.daysRemaining,
              replacements: {
                DAYS: props.daysRemaining,
                ...replacements,
              },
            })
          : translate({
              singular:
                'Unavailable. The original file you uploaded was deleted 7 days after upload. {LINK}Enable for future uploads.{/LINK}',
              replacements,
            })}
      </Paragraph>
    </Box>
  );
};
